import { useAppDispatch } from "@/shared/lib/redux"
import { IJobApplication } from "@/shared/api/employment"
import { closeApproveApplicationModal, closeInspectApplicationModal, closeRejectApplicationModal, openApproveApplicationModal, openInspectApplicationModal, openRejectApplicationModal } from "../../model"

export const useUpdateJobApplicationModal = () => {
    const dispatch = useAppDispatch()
    
    const openInspectJobApplicationModal = (application: IJobApplication) => {
        dispatch(openInspectApplicationModal(application))
    }
    
    const closeInspectJobApplicationModal = () => {
        dispatch(closeInspectApplicationModal())
    }

    const openRejectJobApplicationModal = (application: IJobApplication, onSuccess?: () => void) => {
        dispatch(openRejectApplicationModal({
            data: application,
            onSuccess
        }))
    }
    
    const closeRejectJobApplicationModal = () => {
        dispatch(closeRejectApplicationModal())
    }

    const openApproveJobApplicationModal = (application: IJobApplication, onSuccess?: () => void) => {
        dispatch(openApproveApplicationModal({
            data: application,
            onSuccess
        }))
    }
    
    const closeApproveJobApplicationModal = () => {
        dispatch(closeApproveApplicationModal())
    }

    return {
        closeInspectJobApplicationModal,
        openInspectJobApplicationModal,
        closeApproveJobApplicationModal,
        openApproveJobApplicationModal,
        closeRejectJobApplicationModal,
        openRejectJobApplicationModal
    }
}